import React, { useState, useEffect } from "react";
import {
  IoFlashOutline,
  IoWaterOutline,
  IoColorPaletteOutline,
  IoHammerOutline,
  IoCarOutline,
  IoBedOutline,
  IoRestaurantOutline,
  IoBrushOutline,
  IoPeopleOutline,
  IoConstructOutline,
} from "react-icons/io5";
import "./AddEmployee.css";

const serviceOptions = [
  { name: "Electrician", icon: <IoFlashOutline /> },
  { name: "Plumber", icon: <IoWaterOutline /> },
  { name: "Cleaning", icon: <IoColorPaletteOutline /> },
  { name: "Wood Work", icon: <IoHammerOutline /> },
  { name: "Car Repair", icon: <IoCarOutline /> },
  { name: "Car Driver", icon: <IoCarOutline /> },
  { name: "Home Stay", icon: <IoBedOutline /> },
  { name: "Catering", icon: <IoRestaurantOutline /> }, // fixed typo
  { name: "Painting", icon: <IoBrushOutline /> },
  { name: "Construction & Home Repair", icon: <IoConstructOutline /> },
  { name: "Construction Repairs", icon: <IoConstructOutline /> },
  { name: "Wedding Beautician", icon: <IoPeopleOutline /> },
];

const AddEmployee = () => {
  const [employee, setEmployee] = useState({
    full_name: "",
    phone_number: "",
    email: "",
    username: "",
    password: "",
    department: serviceOptions[0].name,
    designation: serviceOptions[0].name,
    city: "",
    state: "",
    status: "active",
    date_joined: new Date().toISOString().slice(0, 10),
    current_lat: "",
    current_lng: "",
  });

  const [message, setMessage] = useState("");

  // Auto-detect user location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setEmployee((prev) => ({
            ...prev,
            current_lat: position.coords.latitude,
            current_lng: position.coords.longitude,
          }));
        },
        (err) => {
          console.error("Geolocation error:", err);
        }
      );
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployee({ ...employee, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(
        "https://www.actrofiteinfotech.com/rootservices/dashboard/add_employee.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(employee),
        }
      );
      const data = await res.json();
      if (data.success) {
        setMessage("Employee added successfully!");
        setEmployee((prev) => ({
          ...prev,
          full_name: "",
          phone_number: "",
          email: "",
          username: "",
          password: "",
          city: "",
          state: "",
          department: serviceOptions[0].name,
          designation: serviceOptions[0].name,
        }));
      } else {
        setMessage("Error: " + data.message);
      }
    } catch (err) {
      setMessage("Server error: " + err.message);
    }
  };

  return (
    <div className="add-employee-container">
      <h2>Add New Employee</h2>
      <form className="employee-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="full_name"
              value={employee.full_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              name="phone_number"
              value={employee.phone_number}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={employee.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              name="username"
              value={employee.username}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={employee.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>City</label>
            <input
              type="text"
              name="city"
              value={employee.city}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>State</label>
            <input
              type="text"
              name="state"
              value={employee.state}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Department</label>
            <select
              name="department"
              value={employee.department}
              onChange={handleChange}
            >
              {serviceOptions.map((opt, idx) => (
                <option key={idx} value={opt.name}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Designation</label>
            <select
              name="designation"
              value={employee.designation}
              onChange={handleChange}
            >
              {serviceOptions.map((opt, idx) => (
                <option key={idx} value={opt.name}>
                  {opt.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Status</label>
            <input type="text" value={employee.status} disabled />
          </div>
        </div>

        <button type="submit" className="submit-btn1">
          Add Employee
        </button>
      </form>

      {message && <div className="add-employee-message">{message}</div>}
    </div>
  );
};

export default AddEmployee;
